import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/vevo/mascot_peek.png'


const _hoisted_1 = {
  key: 1,
  class: "my-4"
}
const _hoisted_2 = {
  class: "d-flex align-center flex-wrap",
  style: {"gap":"1rem"}
}
const _hoisted_3 = { class: "text-h6 font-weight-bold" }
const _hoisted_4 = { class: "text-caption text-grey" }
const _hoisted_5 = {
  class: "d-flex align-center flex-wrap mt-2 text-body-2 text-grey",
  style: {"gap":"1rem"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  class: "d-flex align-center flex-wrap",
  style: {"gap":"1rem"}
}
const _hoisted_8 = { class: "text-body-2" }
const _hoisted_9 = { class: "d-flex align-center mb-3" }
const _hoisted_10 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_11 = {
  key: 0,
  class: "ai-report-content text-body-1"
}
const _hoisted_12 = {
  class: "d-flex align-center flex-wrap",
  style: {"gap":"0.5rem"}
}
const _hoisted_13 = { class: "text-body-2 mb-1" }
const _hoisted_14 = {
  key: 0,
  class: "text-grey"
}
const _hoisted_15 = { class: "text-body-2 mb-1" }
const _hoisted_16 = {
  key: 0,
  class: "text-grey"
}
const _hoisted_17 = {
  key: 0,
  class: "text-body-2"
}
const _hoisted_18 = {
  key: 1,
  class: "text-body-2 text-grey"
}
const _hoisted_19 = {
  class: "d-flex flex-column",
  style: {"gap":"0.5rem"}
}
const _hoisted_20 = {
  class: "d-flex align-center",
  style: {"gap":"0.5rem"}
}
const _hoisted_21 = {
  class: "d-flex align-center",
  style: {"gap":"0.5rem"}
}
const _hoisted_22 = {
  class: "d-flex align-center",
  style: {"gap":"0.5rem"}
}
const _hoisted_23 = { class: "mt-3 text-body-2" }
const _hoisted_24 = { class: "ma-0 pl-4 text-body-2" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_27 = { class: "mt-2 text-body-2" }
const _hoisted_28 = {
  class: "d-flex mt-4",
  style: {"gap":"0.5rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_ai_report_status_chip = _resolveComponent("ai-report-status-chip")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: _ctx.breadcrumbItems
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, { value: _ctx.pageTitle }, null, 8, ["value"]),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    (_ctx.detail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.detail.lastName) + " " + _toDisplayString(_ctx.detail.firstName), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.detail.className) + " / " + _toDisplayString(_ctx.detail.ageLabel), 1),
            _createVNode(_component_ai_report_status_chip, {
              status: _ctx.detail.status
            }, null, 8, ["status"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, "対象期間: " + _toDisplayString(_ctx.detail.monthsLabel), 1),
            _createElementVNode("span", {
              class: _normalizeClass({ 'text-red': _ctx.detail.dataCoverageMonths.length < 3 })
            }, [
              _createTextVNode(" 発達記録の対象月: " + _toDisplayString(_ctx.formatCoverage(_ctx.detail.dataCoverageMonths)) + " ", 1),
              (_ctx.detail.dataCoverageMonths.length < 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (一部の月のデータのみで生成) "))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("span", null, "生成回数: " + _toDisplayString(_ctx.detail.generationCount) + " 回", 1)
          ]),
          (_ctx.isRegenerating && !_ctx.regenerateDialogOpen)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                variant: "outlined",
                color: "primary",
                icon: "mdi-progress-clock",
                density: "compact",
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, " 再生成中です... (" + _toDisplayString(_ctx.activeBatch ? _ctx.activeBatch.successCount : 0) + " / " + _toDisplayString(_ctx.activeBatch ? _ctx.activeBatch.totalCount : 0) + ") ", 1),
                    _createVNode(_component_v_progress_linear, {
                      indeterminate: "",
                      color: "primary",
                      height: "6",
                      rounded: "",
                      style: {"max-width":"240px"}
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, { class: "mt-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    variant: "outlined",
                    class: "pa-5"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[7] || (_cache[7] = _createElementVNode("img", {
                          src: _imports_0,
                          alt: "VEVO",
                          class: "mr-2",
                          style: {"width":"28px","height":"28px","object-fit":"contain"}
                        }, null, -1)),
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, "レポート本文", -1)),
                        _createVNode(_component_v_spacer),
                        (_ctx.detail.content)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.contentLength) + " 文字 ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.detail.content)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.detail.content), 1))
                        : (_openBlock(), _createBlock(_component_v_alert, {
                            key: 1,
                            type: "info",
                            variant: "outlined",
                            density: "compact"
                          }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createTextVNode(" レポートはまだ生成されていません。クォーター詳細から一括生成、もしくは下の「生成」ボタンを押してください。 ", -1)
                            ]))]),
                            _: 1
                          })),
                      _createVNode(_component_v_divider, { class: "my-4" }),
                      _createElementVNode("div", _hoisted_12, [
                        (_ctx.detail.status === 'draft')
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              color: "primary",
                              variant: "flat",
                              loading: _ctx.isPublishing,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setStatus('published')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { start: "" }, {
                                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createTextVNode("mdi-publish", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[11] || (_cache[11] = _createTextVNode(" 公開する ", -1))
                              ]),
                              _: 1
                            }, 8, ["loading"]))
                          : _createCommentVNode("", true),
                        (_ctx.detail.status === 'published')
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              variant: "outlined",
                              loading: _ctx.isPublishing,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setStatus('draft')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { start: "" }, {
                                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                    _createTextVNode("mdi-undo", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[13] || (_cache[13] = _createTextVNode(" 下書きに戻す ", -1))
                              ]),
                              _: 1
                            }, 8, ["loading"]))
                          : _createCommentVNode("", true),
                        (_ctx.detail.status === 'draft')
                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                              key: 2,
                              disabled: !_ctx.noData,
                              location: "top",
                              text: "対象期間に発達記録がないため生成できません"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                                  _createVNode(_component_v_btn, {
                                    variant: "outlined",
                                    disabled: _ctx.noData || _ctx.isRegenerating,
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.regenerateDialogOpen = true))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, { start: "" }, {
                                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                          _createTextVNode("mdi-refresh", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[15] || (_cache[15] = _createTextVNode(" 再生成 ", -1))
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ], 16)
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.detail.status === 'notGenerated')
                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                              key: 3,
                              disabled: !_ctx.noData,
                              location: "top",
                              text: "対象期間に発達記録がないため生成できません"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                                  _createVNode(_component_v_btn, {
                                    color: "primary",
                                    variant: "outlined",
                                    disabled: _ctx.noData || _ctx.isRegenerating,
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.regenerateDialogOpen = true))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, { start: "" }, {
                                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                          _createTextVNode("mdi-auto-fix", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[17] || (_cache[17] = _createTextVNode(" 生成 ", -1))
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ], 16)
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.detail.status === 'published')
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 2,
                            density: "compact",
                            variant: "outlined",
                            type: "warning",
                            class: "mt-3 text-body-2"
                          }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createTextVNode(" 公開済のため一括再生成ではスキップされます。再生成する場合は先に「下書きに戻す」を実行してください。 ", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    variant: "outlined",
                    class: "pa-5"
                  }, {
                    default: _withCtx(() => [
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-subtitle-2 font-weight-bold text-grey-darken-2 mb-2" }, " 操作ログ ", -1)),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-grey" }, "最終生成:", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.detail.lastGeneratedAt)) + " ", 1),
                        (_ctx.detail.lastGeneratedBy)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, " / by " + _toDisplayString(_ctx.detail.lastGeneratedBy), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-grey" }, "最終公開:", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.detail.lastPublishedAt)) + " ", 1),
                        (_ctx.detail.lastPublishedBy)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, " / by " + _toDisplayString(_ctx.detail.lastPublishedBy), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_v_divider, { class: "my-3" }),
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-subtitle-2 font-weight-bold text-grey-darken-2 mb-2" }, " 直近の再生成 ", -1)),
                      (_ctx.detail.additionalPrompt)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.detail.additionalPrompt), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, " 翻訳なし (通常生成) "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card, {
                    variant: "outlined",
                    class: "pa-4 mt-3"
                  }, {
                    default: _withCtx(() => [
                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-subtitle-2 font-weight-bold text-grey-darken-2 mb-2" }, " ステータスの説明 ", -1)),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_ai_report_status_chip, { status: "notGenerated" }),
                          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-body-2" }, "生成されていない (保護者には非表示)", -1))
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_ai_report_status_chip, { status: "draft" }),
                          _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-body-2" }, "生成済だが未公開 (保護者には非表示)", -1))
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_ai_report_status_chip, { status: "published" }),
                          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-body-2" }, "保護者アプリから閲覧できる", -1))
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.regenerateDialogOpen,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.regenerateDialogOpen) = $event)),
      "max-width": "540",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-5" }, {
          default: _withCtx(() => [
            _createVNode(_component_page_title, { value: _ctx.regenerateDialogTitle }, null, 8, ["value"]),
            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.detail ? `${_ctx.detail.lastName} ${_ctx.detail.firstName}` : "") + " さんのレポートを" + _toDisplayString(_ctx.detail && _ctx.detail.status === "notGenerated" ? "生成" : "再生成") + "します。 ", 1),
            _createVNode(_component_v_alert, {
              variant: "outlined",
              color: "primary",
              icon: "mdi-information-outline",
              density: "compact",
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_24, [
                  (_ctx.regenerateMode === 'translate')
                    ? (_openBlock(), _createElementBlock("li", _hoisted_25, "現在のレポート本文を、選択した言語に翻訳して上書きします。"))
                    : _createCommentVNode("", true),
                  _cache[27] || (_cache[27] = _createElementVNode("li", null, "非同期処理のため完了まで数十秒〜数分かかります。", -1)),
                  _cache[28] || (_cache[28] = _createElementVNode("li", null, [
                    _createTextVNode("完了後、ステータスは "),
                    _createElementVNode("strong", null, "下書き"),
                    _createTextVNode(" に戻ります。")
                  ], -1))
                ])
              ]),
              _: 1
            }),
            (_ctx.canTranslate)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.regenerateMode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.regenerateMode) = $event)),
                    class: "mt-3",
                    density: "compact",
                    "hide-details": "",
                    disabled: !!_ctx.activeBatch && _ctx.activeBatch.status === 'processing'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        label: "単純な再生成 (発達記録から作り直す)",
                        value: "simple"
                      }),
                      _createVNode(_component_v_radio, {
                        label: "翻訳 (現在の本文を選択言語に翻訳)",
                        value: "translate"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]),
                  (_ctx.regenerateMode === 'translate')
                    ? (_openBlock(), _createBlock(_component_v_select, {
                        key: 0,
                        modelValue: _ctx.selectedLanguage,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
                        items: _ctx.languageItems,
                        "item-title": "label",
                        "item-value": "code",
                        label: "翻訳先の言語",
                        variant: "outlined",
                        density: "compact",
                        class: "mt-3",
                        disabled: !!_ctx.activeBatch && _ctx.activeBatch.status === 'processing'
                      }, null, 8, ["modelValue", "items", "disabled"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.activeBatch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_v_progress_linear, {
                    "model-value": _ctx.batchProgressPercent,
                    indeterminate: _ctx.activeBatch.status === 'processing' && _ctx.activeBatch.successCount === 0,
                    color: "primary",
                    height: "10",
                    rounded: ""
                  }, null, 8, ["model-value", "indeterminate"]),
                  _createElementVNode("p", _hoisted_27, [
                    (_ctx.activeBatch.status === 'processing')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.detail && _ctx.detail.status === "notGenerated" ? "生成中" : "再生成中") + "... (" + _toDisplayString(_ctx.activeBatch.successCount) + " / " + _toDisplayString(_ctx.activeBatch.totalCount) + ") ", 1)
                        ], 64))
                      : (_ctx.activeBatch.status === 'completed')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_v_icon, {
                              size: "small",
                              color: "success"
                            }, {
                              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                _createTextVNode("mdi-check-circle", -1)
                              ]))]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.detail && _ctx.detail.status === "notGenerated" ? "生成" : "再生成") + "が完了しました。 ", 1)
                          ], 64))
                        : (_ctx.activeBatch.status === 'failed')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                color: "red"
                              }, {
                                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                  _createTextVNode("mdi-alert-circle", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.detail && _ctx.detail.status === "notGenerated" ? "生成" : "再生成") + "に失敗しました。 ", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _ctx.closeRegenerateDialog,
                disabled: _ctx.isStartingRegenerate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.activeBatch && _ctx.activeBatch.status === "completed" ? "閉じる" : "キャンセル"), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              (!_ctx.activeBatch || _ctx.activeBatch.status === 'failed')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: "primary",
                    variant: "flat",
                    loading: _ctx.isStartingRegenerate,
                    disabled: _ctx.startRegenerateDisabled,
                    onClick: _ctx.startRegenerate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.startButtonLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}